// @ts-nocheck
export default {
  pt: {
    HERO_TITLE_SORRY:
      'Lo sentimos, esta promoción es válida solo para nuevos usuarios',
    HERO_DESCRIPTION_SORRY:
      'No dejes de ver tu buzón de correo que pronto anunciaremos promociones pensadas para ti',

    FORM_EMAIL_LABEL: 'E-mail',
    FORM_PASSWORD_LABEL: 'Senha',
    FORM_COUPON_LABEL: 'Código del cupón',
    FORM_REQUIRED: 'Campo requerido',
    FORM_MAX_LENGTH: 'Máximo 300 caracteres',
    FORM_MIN_LENGTH: 'Mínimo 6 caracteres',
    FORM_EMAIL_VALID: 'Por favor, ingresa un email válido',
    FORM_TERMS_1: 'Al registrarte aceptas nuestros',
    FORM_TERMS_2: 'Términos y Políticas de Privacidad.',

    STEPS_TITLE: 'Aquí te explicamos como funciona',
    STEPS_1_TITLE: 'Regístrate',
    STEPS_1_DESCRIPTION: 'Completa tus datos y sé partede nuestra comunidad',
    STEPS_2_TITLE: 'Ingresa tu cupón',
    STEPS_2_DESCRIPTION: 'Utiliza el código',
    STEPS_3_TITLE: 'Empieza tu prueba',
    STEPS_3_DESCRIPTION: 'Tendrás 7 días de acceso total a +500 cursos',
  },
};
